import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8539e6b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex justify-center gap-5 mt-2" };
const _hoisted_2 = { class: "text-2xl font-semibold" };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = ["disabled"];
import LiveChatIcon from '@/assets/common/LiveChatIcon.vue';
import SmsOrEmailIcon from '@/assets/common/SmsOrEmailIcon.vue';
import WaChatIcon from '@/assets/common/WaChatIcon.vue';
import { CHAT_WIDGET_IDS, ChatType } from '@/helper/const';
import { i18n } from '@/plugin/vue-i18n';
import { UIButton, UIDivider, UIModal, UIModalHeader, UITextSmRegular, } from '@gohighlevel/ghl-ui';
import { inject, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChatTypeSelectorDialog',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        showWhatsapp: {
            type: Boolean,
            default: false,
        },
        locationId: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: [
        'email-chat',
        'live-chat',
        'whatsapp-chat',
        'close-modal',
    ],
    setup(__props, { emit }) {
        const props = __props;
        const router = inject('router');
        const whatsappDisabled = ref('');
        const handleOptionClick = optionKey => {
            const clickedOption = chatOptions.value.find(option => option.key === optionKey);
            chatOptions.value.forEach(option => {
                option.disabled = true;
            });
            if (clickedOption) {
                clickedOption.loading = true;
            }
            switch (optionKey) {
                case ChatType.EMAIL_CHAT:
                    emit('email-chat');
                    whatsappDisabled.value = 'disabled';
                    break;
                case ChatType.LIVE_CHAT:
                    emit('live-chat');
                    whatsappDisabled.value = 'disabled';
                    break;
                case ChatType.WA_CHAT:
                    emit('whatsapp-chat');
                    break;
                default:
                    break;
            }
        };
        const chatOptions = ref([
            {
                key: ChatType.EMAIL_CHAT,
                title: i18n.global.t('common.smsOrEmailChat'),
                subHeader: i18n.global.t('createNewChatTypeModal.smsOrEmailSubHeader'),
                icon: SmsOrEmailIcon,
                clickHandler: () => handleOptionClick(ChatType.EMAIL_CHAT),
                showButton: true,
                loading: false,
                disabled: false,
            },
            {
                key: ChatType.LIVE_CHAT,
                title: i18n.global.t('common.liveChat'),
                subHeader: i18n.global.t('createNewChatTypeModal.liveChatSubHeader'),
                icon: LiveChatIcon,
                clickHandler: () => handleOptionClick(ChatType.LIVE_CHAT),
                showButton: true,
                loading: false,
                disabled: false,
            },
            {
                key: ChatType.WA_CHAT,
                title: i18n.global.t('common.waChat'),
                subHeader: i18n.global.t('createNewChatTypeModal.whatsappSubHeader'),
                icon: WaChatIcon,
                clickHandler: () => handleOptionClick(ChatType.WA_CHAT),
                showButton: props.showWhatsapp,
                loading: false,
                disabled: false,
            },
        ]);
        const handleWhatsappClick = () => {
            router.push({
                name: 'whatsapp-v1',
                params: { location_id: props.locationId },
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: props.show,
                width: 946
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "pg-chat-widget-template-selector__header",
                        title: _ctx.$t('createNewChatTypeModal.modalHeader'),
                        description: _ctx.$t('createNewChatTypeModal.modalSubHeader'),
                        onClose: _cache[0] || (_cache[0] = ($event) => (emit('close-modal'))),
                        class: "mb-2"
                    }, null, 8 /* PROPS */, ["title", "description"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIDivider)),
                    _createElementVNode("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatOptions.value, (chatOption) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: chatOption.key,
                                class: "flex justify-between flex-col text-center p-4 border-2 gap-4 rounded-xl border-gray-300 group hover:bg-primary-100 hover:border-primary-600 relative group items-center flex-1 w-72"
                            }, [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(chatOption.title), 1 /* TEXT */),
                                _createVNode(_unref(UITextSmRegular), null, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(chatOption.subHeader), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                (_openBlock(), _createBlock(_resolveDynamicComponent(chatOption.icon))),
                                (chatOption.showButton === true || props.showWhatsapp)
                                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                                        key: 0,
                                        id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_BUTTON,
                                        onClick: chatOption.clickHandler,
                                        class: "text-primary-300 bg-primary-25 group-hover:bg-primary-600 group-hover:text-white",
                                        type: "transparent",
                                        loading: chatOption.loading,
                                        disabled: chatOption.disabled
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('common.select')), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "onClick", "loading", "disabled"]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_3, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('createNewChatTypeModal.setupYour')) + " ", 1 /* TEXT */),
                                        _createElementVNode("a", {
                                            disabled: whatsappDisabled.value,
                                            onClick: handleWhatsappClick,
                                            class: _normalizeClass({ disabled: whatsappDisabled.value })
                                        }, _toDisplayString(_ctx.$t('common.waChat')), 11 /* TEXT, CLASS, PROPS */, _hoisted_4),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('createNewChatTypeModal.number')), 1 /* TEXT */)
                                    ]))
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"]));
        };
    }
});
